import { apiService } from "../store";
import { fetchKanban, messageError } from "./index";
import { childRequested } from "./child";
import { formatPhoneNumber } from "../../helpers";

export const clientsRequested = () => {
  return {
    type: "CLIENTS_REQUESTED",
  };
};
export const clientsError = (error) => {
  return {
    type: "CLIENTS_ERROR",
    payload: error,
  };
};
export const clientsLoaded = (newClients) => {
  return {
    type: "CLIENTS_LOADED",
    payload: newClients,
  };
};
export const allClientsLoaded = (newClients) => {
  return {
    type: "ALL_CLIENTS_LOADED",
    payload: newClients,
  };
};
export const setClientId = (id) => {
  return {
    type: "CLIENT_ID",
    payload: id,
  };
};
export const updateClientAction = (payload) => {
  return {
    type: "UPDATE_CLIENT",
    payload,
  };
};
export const clientRequested = () => {
  return {
    type: "CLIENT_REQUESTED",
  };
};
export const clientError = (error) => {
  return {
    type: "CLIENT_ERROR",
    payload: error,
  };
};
export const clientLoaded = (newClients) => {
  return {
    type: "CLIENT_LOADED",
    payload: newClients,
  };
};
export const clientDiscountLoaded = (discount) => {
  return {
    type: "CLIENT_DISCOUNT_LOADED",
    payload: discount,
  };
};
export const sourceLoaded = (sources) => {
  return {
    type: "SOURCE_LOADED",
    payload: sources,
  };
};
export const statusClientLoaded = (status) => {
  return {
    type: "STATUS_CLIENT_LOADED",
    payload: status,
  };
};
export const passwordUpdated = (data) => {
  return {
    type: "PASSWORD_WAS_UPDATED",
    payload: data,
  };
};

export const clientCreate = (client) => (dispatch) => {
  apiService
    .createClient(client)
    .then((data) => {
      dispatch(updateClientAction(data));
      dispatch(fetchKanban());
      dispatch(fetchClients());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const clientDelete = (client) => (dispatch) => {
  apiService
    .deleteClient(client)
    .then(() => {
      dispatch(fetchClients());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const allClientDelete = (client) => (dispatch) => {
  apiService
    .deleteClient(client)
    .then(() => {
      dispatch(fetchClientsAll());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const fetchClients = () => (dispatch) => {
  dispatch(clientsRequested());
  apiService
    .getClientsRequests()
    .then((data) => {
      const clients = data.map((item) => ({
        ...item,
        full_name: `${item.last_name} ${item.first_name} ${
          item.middle_name !== null ? item.middle_name : ""
        }`,
        date:
          new Date(item.created_at).getDate() +
          "." +
          (new Date(item.created_at).getMonth() + 1) +
          "." +
          new Date(item.created_at).getFullYear(),
      }));
      dispatch(clientsLoaded(clients));
    })
    .catch((err) => dispatch(clientsError(err)));
};

export const fetchClientsAll = () => (dispatch) => {
  dispatch(clientsRequested());
  apiService
    .getAllClientsRequests()
    .then((data) => {
      dispatch(allClientsLoaded(data));
    })
    .catch((err) => dispatch(clientsError(err)));
};

export const fetchDiscountClient = () => (dispatch) => {
  apiService
    .discountsClientRequest()
    .then((data) => {
      dispatch(clientDiscountLoaded(data));
    })
    .catch((err) => dispatch(clientsError(err)));
};

export const fetchClient = (id) => (dispatch) => {
  dispatch(clientRequested());
  apiService
    .getClientRequest(id)
    .then((data) => {
      const client = { ...data, history: data.history };
      dispatch(clientLoaded(client));
    })
    .catch((err) => dispatch(clientError(err)));
};

export const saveFileAdmin = (file, collection, id) => (dispatch) => {
  apiService.savePhoto(file, collection, id).then(() => {
    apiService.childRequest(id).then((data) => {
      dispatch(childRequested(data));
    });
  });
};

export const savePhotoAdmin = (file, collection, id) => (dispatch) => {
  apiService.savePhoto(file, collection, id).then(() => {
    apiService.childRequest(id).then((data) => {
      dispatch(childRequested(data));
    });
  });
};

export const deleteFileAdmin =
  (collection, id, mediaID, client_id) => (dispatch) => {
    apiService.delMedia(collection, id, mediaID).then(() => {
      apiService.childRequest(id).then((data) => {
        dispatch(childRequested(data));
      });
    });
  };

export const updateClient = (payload) => (dispatch) => {
  apiService
    .updateClient(payload)
    .then((client) => {
      dispatch(fetchClients());
      apiService
        .getClientRequest(client.id)
        .then((data) => {
          if (data?.phone) {
            data.phone = formatPhoneNumber(data.phone);
          }
          const client = { ...data, history: data.history };
          dispatch(clientLoaded(client));
        })
        .catch((err) => dispatch(clientError(err)));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const updateClientFromChild = (payload) => (dispatch) => {
  apiService
    .updateClient(payload)
    .then((client) => {
      dispatch(fetchClient(client.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const createDiscountClient = (client, payload) => (dispatch) => {
  const discount = { discount_ids: payload };
  client.phone = client.phone.replace(/\D+/g, "");

  return apiService
    .setClientDiscount(client.id, discount)
    .then(() => {
      dispatch(updateClient(client));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const setClientPassword = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
      const {id, password} = payload
      apiService
          .setNewPassword(id, password)
          .then((data) => {
              dispatch(passwordUpdated(data))
              resolve()
          })
          .catch((err) => {
              dispatch(messageError(err.response.data.message));
              reject()
          });
  })
}

export const createHistoryClient = (required, payload) => (dispatch) => {
  apiService
    .createHistory(required, payload)
    .then(() => {
      apiService
        .getClientRequest(payload.id)
        .then((data) => {
          const client = { ...data, history: data.history };
          dispatch(clientLoaded(client));
        })
        .catch((err) => dispatch(clientError(err)));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const getSourcesClient = () => (dispatch) => {
  apiService
    .sourceClientRequest()
    .then((data) => {
      dispatch(sourceLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const getStatusClient = () => (dispatch) => {
  apiService
    .statusClientRequest()
    .then((data) => {
      dispatch(statusClientLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
